import { CustomRangeSlider, ErrorMessage, Heading, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { IMatchMakerAnswers } from "../../interfaces";
import { BrandType as Brand } from "@bus/models";
import { capitalizeBrand } from "../../helpers/capitalizeBrand";

export const MonthlyBudget = () => {
    const { t } = useTranslation(["question2page"]);
    const { values, errors, setFieldValue, touched } = useFormikContext<IMatchMakerAnswers>();
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const getTitle = () => {
        switch (brand) {
            case Brand.AUDI:
            case Brand.SKODA:
                return t("question2page:monthly-budget.titleAlternative", {
                    brand: capitalizeBrand(brand as Brand),
                });
            case Brand.VW:
                return t("question2page:monthly-budget.titleVW");
            case Brand.VWN:
                return t("question2page:monthly-budget.titleVWN");
            default:
                return t("question2page:monthly-budget.title", {
                    brand: capitalizeBrand(brand as Brand),
                });
        }
    }
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">
                {getTitle()}
            </Heading>

            <CustomRangeSlider
                onChange={(e) => {
                    if (typeof e === 'string') {
                        setFieldValue("monthlyPayment", parseInt(e));
                    } else {
                        setFieldValue("monthlyPayment", e);
                    }
                }}
                tooltipPosition="top"
                range={{
                    max: 1500,
                    min: 150,
                }}
                step={1}
                tooltips={{ to: (e) => e.toFixed(0) + t("question2page:monthly-budget.tooltip") }}
                value={values.monthlyPayment || 150}
                className="u-mr-large@s u-ml-large@s"
            />
            {touched["monthlyPayment"] && errors["monthlyPayment"] && (
                <Layout>
                    <Layout.Item>
                        <ErrorMessage id={`monthlyPayment`}>{errors["monthlyPayment"] as string}</ErrorMessage>
                    </Layout.Item>
                </Layout>
            )}
        </>
    );
};
